import React, { useEffect, useState } from "react"
import { useTranslation } from 'react-i18next'
import { Link } from "react-router-dom"
import { Dropdown, Modal } from "react-bootstrap"
import Select from "react-select"

import FilterSearch from 'pages/parts/FilterSearch'
import FilterPagination from 'pages/parts/FilterPagination'
import BroadcastModal from 'pages/parts/BroadcastModal'
import { httpOk, GET, PUT, POST } from 'helpers/api'
import { formatMoney, formatDate, regexPhoneNumber, isColumnHidden } from 'helpers/helpers'

function Index({ modal, setModal, selectClient }) {
	const { t } = useTranslation()

	// Ustun qulfi (super-admin POS uchun yashirgan). Aktiv + Oxirgi xarid bitta kalitга bog'liq
	// (ikkovi last_cheque_date'dan — biri ochiq qolsa ikkinchisini oshkor qiladi).
	const hideDebtAge = isColumnHidden('col.report_clients.debt_age')
	const hidePayRel = isColumnHidden('col.report_clients.pay_reliability')
	const hideLastBuy = isColumnHidden('col.report_clients.last_purchase')
	const colCount = 11 - (hideLastBuy ? 2 : 0) - (hideDebtAge ? 1 : 0) - (hidePayRel ? 1 : 0)

	const [showModal, setShowModal] = useState(false)
	const [selectedItem, setSelectedItem] = useState({})
	const [clientTypes, setClientTypes] = useState([])

	const [filterData, setFilterData] = useState({})
	const [pagination, setPagination] = useState({ url: '/report-clients', response: null })
	const [data, setData] = useState({ data: [], total: 0, total_amount: 0, total_debt_amount: 0 })

	/* XABAR YUBORISH — shu ekrandan (qarz yoshi bo'yicha nishonga olish uchun).
	   Hech kim belgilanmasa modal buni ochiq aytadi: xabar hammaga ketadi. */
	const [smsModal, setSmsModal] = useState(false)
	const [selectedClients, setSelectedClients] = useState([])

	const pageIds = (data.data || []).map(x => x.client_id).filter(Boolean)
	const pageAllSelected = pageIds.length > 0 && pageIds.every(id => selectedClients.includes(id))

	function togglePage(on) {
		setSelectedClients(prev => on
			? Array.from(new Set([...prev, ...pageIds]))
			: prev.filter(id => !pageIds.includes(id)))
	}

	function toggleClient(id) {
		setSelectedClients(prev => prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id])
	}

	async function searchWithFilter() {
		const response = await GET('/report-clients', filterData, { loader: true })
		if (httpOk(response)) {
			setData(response.data)
			setPagination(prev => ({ ...prev, response: response.data }))
		}
	}

	async function createUpdate(e) {
		e.preventDefault()
		const copy = { ...selectedItem, id: selectedItem.client_id }
		const response = copy.id
			? await PUT('/clients', copy, { loader: true })
			: await POST('/clients', copy, { loader: true })
		if (httpOk(response)) {
			searchWithFilter()
			toggleModal(false)
		}
	}

	function handleInputChange(e) {
		setSelectedItem(prev => ({ ...prev, [e.target.name]: e.target.value }))
	}

	async function toggleModal(bool, item = { gender: 1 }) {
		setSelectedItem(bool ? { ...item } : {})
		setShowModal(bool)
	}

	async function getClientTypes() {
		const response = await GET('/helper/clients-types')
		if (httpOk(response)) setClientTypes(response.data)
	}

	function activityBadge(dateStr) {
		if (!dateStr) return null
		const days = Math.floor((Date.now() - new Date(dateStr)) / 86400000)
		if (days <= 30)  return { label: t('active'),     bg: '#d1e7dd', color: '#0f5132' }
		if (days <= 60)  return { label: t('low_active'), bg: '#fff3cd', color: '#664d03' }
		return               { label: t('inactive'),   bg: '#f8d7da', color: '#842029' }
	}

	function reliabilityColor(pct) {
		if (pct == null) return 'text-muted'
		if (pct >= 80) return 'text-success'
		if (pct >= 50) return 'text-warning'
		return 'text-danger'
	}

	useEffect(() => { getClientTypes() }, []) // eslint-disable-line react-hooks/exhaustive-deps

	useEffect(() => {
		searchWithFilter()
	}, [filterData.search, filterData.page, filterData.size, filterData.client_type]) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<>
			<div className={`page-header d-flex justify-content-between ${modal ? 'modal-page' : ''}`}>
				<h4 className="vertical-center h-100">
					{t('clients')} [{data.total ?? 0}]
				</h4>

				{/* ⚠️ XABAR YUBORISH aynan SHU ekranda eng foydali: bu yerda qarz yoshi,
				    to'lov intizomi va faollik ko'rinadi — 1013 kishiga emas, kerakli
				    40 kishiga yuboriladi. Modal ikkala mijozlar ekranida BITTA komponent
				    (pages/parts/BroadcastModal). Tanlov oynasida (modal=true) chiqmaydi. */}
				{!modal &&
					<button type="button" className="btn btn-primary vertical-center"
						onClick={() => setSmsModal(true)}>
						<i className="uil-comment-alt-message me-1" />
						{t('sms_sending')}
						{selectedClients.length > 0 &&
							<span className="badge bg-light text-dark ms-2">{selectedClients.length}</span>}
					</button>
				}
			</div>

			<div className={`card ${modal ? 'modal-page' : ''}`}>
				<div className="card-body">

					{/* Filters row */}
					<div className="d-flex flex-wrap gap-2 mb-3">
						<FilterSearch filterData={filterData} setFilterData={setFilterData} />
						<div style={{ width: '200px' }}>
							<Select
								options={clientTypes}
								value={clientTypes.find(o => o.id === filterData.client_type) || ''}
								onChange={o => setFilterData(prev => ({ ...prev, client_type: o?.id, page: 0 }))}
								placeholder={t('client_types')}
								noOptionsMessage={() => t('list_empty')}
								getOptionLabel={o => o.name}
								getOptionValue={o => o.id}
								isClearable
							/>
						</div>
					</div>

					{/* Totals top */}
					<div className="d-flex justify-content-end mb-2 pe-1">
						<div className="text-end">
							<div className="fw-bold text-success">{formatMoney(data.total_amount)}</div>
							<div className="fw-bold text-danger">{formatMoney(data.total_debt_amount)}</div>
						</div>
					</div>

					{/* Table */}
					<div className="table-responsive">
						<table className="table table-bordered table-hover mb-0">
							<thead>
								<tr>
									{!modal &&
										<th style={{ minWidth: '34px' }} className="text-center">
											<input type="checkbox" className="form-check-input"
												checked={pageAllSelected}
												onChange={e => togglePage(e.target.checked)} />
										</th>
									}
									<th style={{ minWidth: '33px' }} className="text-center">#</th>
									<th style={{ width: '20%' }}>{t('client')}</th>
									<th style={{ width: '11%' }}>{t('phone')}</th>
									<th style={{ width: '9%' }}>{t('type')}</th>
									{!hideLastBuy && <th style={{ width: '8%' }} className="text-center">{t('active')}</th>}
									{!hideLastBuy && <th style={{ width: '9%' }} className="text-center">{t('last_purchase')}</th>}
									{!hideDebtAge && <th style={{ width: '8%' }} className="text-center">{t('debt_age')}</th>}
									{!hidePayRel && <th style={{ width: '8%' }} className="text-center">{t('pay_reliability')}</th>}
									<th style={{ width: '12%' }} className="text-end">{t('sale_amount')}</th>
									<th style={{ width: '10%' }} className="text-end">{t('amount_of_debt')}</th>
									<th style={{ minWidth: '33px' }}></th>
								</tr>
							</thead>
							<tbody>
								{data.data?.map((item, index) => (
									<tr className="tr-middle" key={index}>
											{!modal &&
												<td className="text-center" onClick={e => e.stopPropagation()}>
													<input type="checkbox" className="form-check-input"
														checked={selectedClients.includes(item.client_id)}
														onChange={() => toggleClient(item.client_id)} />
												</td>
											}
											<td className="text-center">{item.row_number}</td>
											<td className="td-ellipsis">
												{modal
													? <span className="text-primary cursor"
														onClick={() => selectClient(item)}>{item.name}</span>
													: <Link className="text-primary table-first-column-clickable"
														to={`/report-clients-debts/${item.client_id}`}>{item.name}</Link>
												}
											</td>
											<td className="text-nowrap">{regexPhoneNumber(item.phone) || '—'}</td>
											<td>{item.client_type_name || '—'}</td>
											{!hideLastBuy && <td className="text-center text-nowrap">
												{(() => {
													const ab = activityBadge(item.last_cheque_date)
													return ab
														? <span className="badge" style={{ backgroundColor: ab.bg, color: ab.color }}>{ab.label}</span>
														: <span className="text-muted">—</span>
												})()}
											</td>}
											{!hideLastBuy && <td className="text-center text-nowrap">
												{item.last_cheque_date
													? formatDate(item.last_cheque_date, 'dd.MM.yyyy')
													: <span className="text-muted">—</span>
												}
											</td>}
											{!hideDebtAge && <td className="text-center text-nowrap">
												{item.debt_age_days != null
													? <span className={item.debt_age_days > 30 ? 'text-danger' : 'text-warning'}>
														{item.debt_age_days} {t('days_short')}
													</span>
													: <span className="text-muted">—</span>
												}
											</td>}
											{!hidePayRel && <td className="text-center text-nowrap">
												{item.pay_reliability != null
													? <span className={reliabilityColor(item.pay_reliability)}>
														{item.pay_reliability}%
													</span>
													: <span className="text-muted">—</span>
												}
											</td>}
											<td className="text-end text-nowrap text-success">
												{formatMoney(item.total_sales)}
											</td>
											<td className={`text-end text-nowrap ${item.balance < 0 ? 'text-danger' : ''}`}>
												{formatMoney(item.balance)}
											</td>
											<td>
												<div className="table-dropdown">
													<Dropdown id={`dd-${index}`}>
														<Dropdown.Toggle variant="outline-primary">
															<i className="uil uil-ellipsis-v"></i>
														</Dropdown.Toggle>
														<Dropdown.Menu>
															<div className="table-dropdown-item"
																onClick={() => toggleModal(true, item)}>
																<i className="uil-edit-alt"></i>
																{t('edit')}
															</div>
														</Dropdown.Menu>
													</Dropdown>
												</div>
											</td>
									</tr>
								))}
								{(!data.data || data.data.length === 0) &&
									<tr><td colSpan={colCount} className="text-center text-muted py-4">{t('list_empty')}</td></tr>
								}
							</tbody>
						</table>
					</div>

					{pagination.response &&
						<FilterPagination pagination={pagination}
							paginate={(page, size) => setFilterData(prev => ({ ...prev, page, size }))} />
					}

				</div>
			</div>

			{/* Edit/Create Modal */}
			<Modal show={showModal} animation={false} centered backdrop="static"
				dialogClassName="update-modal-width" onHide={() => toggleModal(false)}>
				<Modal.Header closeButton>
					<Modal.Title>{selectedItem.client_id ? t('edit') : t('create')}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<form onSubmit={createUpdate} autoComplete="off">
						<div className="form-group">
							<label>{t('name')}<span className="required-mark">*</span></label>
							<input type="text" className="form-control" name="name"
								value={selectedItem.name ?? ''}
								onChange={handleInputChange} />
						</div>
						<div className="form-group">
							<label>{t('phone')}</label>
							<input type="number" className="form-control" name="phone"
								value={selectedItem.phone ?? ''}
								onChange={handleInputChange} />
						</div>
						<div className="form-group">
							<label>{t('phone')} (2)</label>
							<input type="number" className="form-control" name="phone2"
								value={selectedItem.phone2 ?? ''}
								onChange={handleInputChange} />
						</div>
						<div className="form-group">
							<label>{t('client_types')}</label>
							<Select
								isClearable
								options={clientTypes}
								value={clientTypes.find(o => o.id === selectedItem.client_type_id) || ''}
								onChange={o => setSelectedItem(prev => ({ ...prev, client_type_id: o?.id }))}
								placeholder=""
								noOptionsMessage={() => t('list_empty')}
								getOptionLabel={o => o.name}
								getOptionValue={o => o.id}
							/>
						</div>
						<div className="form-group">
							<label>{t('note')}</label>
							<input type="text" className="form-control" name="note"
								value={selectedItem.note ?? ''}
								onChange={handleInputChange} />
						</div>
						<div className="d-flex gap-2 w-100 mt-3">
							<button type="button" className="btn btn-outline-warning w-100"
								onClick={() => toggleModal(false)}>{t('cancel')}</button>
							<button type="submit" className="btn btn-primary w-100">{t('save')}</button>
						</div>
					</form>
				</Modal.Body>
			</Modal>

			{/* Xabar yuborish — ikkala mijozlar ekranida bitta komponent */}
			<BroadcastModal show={smsModal} onHide={() => setSmsModal(false)}
				clientIds={selectedClients} />
		</>
	)
}

export default Index
